import { createAction, props } from '@ngrx/store';
import { ApiError } from '@shared-models/api-error';

export const SetSystemError = createAction('[SHARED] Set system error', props<{ payload: ApiError }>());
export const ClearSystemError = createAction('[SHARED] Clear system error');
